// extracted by mini-css-extract-plugin
export default {"container":"ProjectDetailsPopover-module__container--PmaNx","label":"ProjectDetailsPopover-module__label--opkOs","status":"ProjectDetailsPopover-module__status--R0gni"};